import React from 'react';
// mui components
import { Typography } from '@mui/material';
// draft-js-plugins types
import { SubMentionComponentProps } from '@draft-js-plugins/mention/lib/Mention';

const Mention: React.FC<SubMentionComponentProps> = ({ decoratedText }) => {
  return (
    <Typography
      sx={{
        display: 'inline-block',
        padding: '0 2px',
        borderRadius: '8px',
        background: '#E7ECFF',
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '146%',
        color: '#3652C6',
      }}
    >
      {decoratedText}
    </Typography>
  );
};

export default Mention;
